<template>
  <span class="fs-14 secondary-text">
    {{unitFormatLabel}}
    <span v-if="format != null && volume != null">
      - {{getFormat}}
    </span>
  </span>
</template>
<script>
import ProductUtil from '@/utils/product-util'

export default {
  name: 'UnitFormatVolumeLabel',
	props: {
    unit : {
      type : Number,
      required: true,
    },
    uvc : {
      type : Number,
      required: true,
    },
    format : {
      type : Number
    },
    volume : {
      type : Number
    }
	},
  data() {
    return {

    };
  },
	computed: {
    getFormat(){
      return ProductUtil.getFormatLabel(this.volume, this.format);
    },
    unitFormatLabel(){
      return ProductUtil.getUnitFormatLabel(this.unit, this.uvc);
    },
	},
  mounted(){

  },
  created(){

  }
}
</script>
<style>
</style>
